import React from 'react';
import './DataBlock.scss';
import NumberHelper from '../../utils/NumberHelper';

const DataBlock = (props) => {
    const iconClasses = `ghg-icon ghg-icon-${props.icon}`;
    const icon = props.icon ?
        <span className={iconClasses} aria-hidden="true">&nbsp;</span> :
        <i className="fa fa-car" aria-hidden="true">&nbsp;</i>;

    const output = NumberHelper.formatOutput(props.outputValue);
    let hash = "";
    if (props.icon === "home") {
    hash = "home";
    }
    if (props.icon === "car") {
    hash = "car";
    }
    if (props.icon === "wind") {
    hash = "wind";
    }
    if (props.icon === "solar") {
    hash = "solar";
    }
    return (
        <div className="ghg-equiv ghg-grid-col ghg-grid-2">
            <div className="ghg-equiv-top">
                <div className="ghg-equiv-info">
                    <a href={"https://www.epa.gov/greenpower/green-power-equivalency-calculator-calculations-and-references#" + hash}target="_blank"><i className="fa fa-info-circle" aria-hidden="true">&nbsp;</i></a>
                </div>
                <div className="ghg-equiv-output">
                    <span className="ghg-equiv-text">{output}</span>
                </div>
            </div>
            <div className="ghg-equiv-body">
                <div className="ghg-equiv-icon">
                    {icon}
                </div>
                <div className="ghg-equiv-explanation ghg-details">
                    <span className="ghg-equiv-explanation-text">{props.description}</span>
                </div>
            </div>
        </div>
    );
};

export default DataBlock;


/** WEBPACK FOOTER **
 ** ./src/components/DataBlock/DataBlock.js
 **/